import ObjectState from './container'

export default ObjectState
